/* ARCHIVIO */
export const SYNC_ARCHIVIO = "SYNC_ARCHIVIO"
export const SYNC_ARCHIVIO_PROGRESS = "SYNC_ARCHIVIO_PROGRESS"
export const SYNC_ARCHIVIO_SUCCESS = "SYNC_ARCHIVIO_SUCCESS"
export const SYNC_ARCHIVIO_FAIL = "SYNC_ARCHIVIO_FAIL"
export const ARCHIVIO_LOCAL_CHANGED = "ARCHIVIO_LOCAL_CHANGED"
